<template>
  <a-tree-select
    v-if="currField && currField.fieldtype === 'select_tree'"
    :value="data.weoptionkey + '' || ''"
    :tree-data="newOptions"
    :allow-clear="true"
    placeholder="请选择"
    tree-default-expand-all
    tree-node-filter-prop="title"
    @focus="focusSelectTree"
    @change="handleChangeTree($event)"
  />
  <a-select
    v-else
    :value="data.weoptionkey || undefined"
    :allow-clear="true"
    placeholder="请选择"
    dropdown-class-name="wefieldkey-child-select"
    :get-popup-container="
      triggerNode => {
        return triggerNode.parentNode || document.body;
      }
    "
    @dropdownVisibleChange="handleVisibleSelect"
    @change="handleChangeSelect($event)"
  >
    <a-select-option
      v-if="filterOptions && filterOptions.length === 0"
      key="empty"
      class="empty"
    >
      <i class="iconfont iconicon-test38" />
      暂无选项
    </a-select-option>
    <a-select-option
      v-for="(one) in newOptions"
      :key="one.id"
      :value="one.id"
      :disabled="one.chooseed"
      :class="{ hide: one.chooseed }"
    >
      {{ one.fieldname || one.name }}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      newOptions: [],
      filterOptions: [],
      isSelectTree: false
    }
  },

  computed: {
    currField () {
      return this.row.currField
    },
    fieldtype () {
      return this.currField.fieldtype
    },

    allOptionSelected () {
      let arr = []
      let { assoc = [] } = this.row

      assoc.forEach((item = {}) => {
        let { weoptionkey } = item
        if (weoptionkey && !arr.includes(weoptionkey)) {
          arr.push(weoptionkey)
        }
      })

      return arr
    }
  },

  watch: {
    data: {
      handler (val) {
        if (!val || this.isSelectTree) return
        this.setDefaultValue()
      },
      deep: true,
      immediate: true
    },
    row: {
      handler (val) {
        if (!val) return
        this.setNewOptions()
      },
      deep: true,
      immediate: true
    },
    allOptionSelected (val) {
      this.setSelectOptionChooseed()
    },
    newOptions (val) {
      this.filterOptions = this.newOptions.filter(item => !item.chooseed)
    }
  },

  methods: {
    setDefaultValue () {
      let { options = [] } = this.row
      let { weoptionkey = undefined } = this.data

      if (!options.length) return

      if (this.fieldtype === 'select_tree') {
        let isFind = this.findTreeValue(options, weoptionkey)
        if (!isFind && weoptionkey) {
          this.data.weoptionkey = ''
        }
      } else {
        if (!options.find(item => item.id === weoptionkey)) {
          this.data.weoptionkey = undefined
        }
      }
      this.$forceUpdate()
    },
    findTreeValue (children, weoptionkey) {
      return children.some(item => {
        if (parseInt(item.id) === parseInt(weoptionkey)) {
          return true
        }

        if (item.children && item.children.length) {
          return this.findTreeValue(item.children, weoptionkey)
        }
      })
    },

    // 树形下拉和下拉处理列表数据
    setNewOptions () {
      let { currField = {}, options = [] } = this.row
      let { fieldtype = '' } = currField || {}

      if (fieldtype === 'select_tree' && options.length) {
        options = this.setTreeOptions(options)
      } else if (fieldtype === 'radioinfo_level') {
        options = this.setLevelOptions(JSON.parse(JSON.stringify(options)))
      }

      this.newOptions = options
    },

    // 处理需求设备等树形下拉数据
    setTreeOptions (options) {
      let arr = options.map(item => {
        item.disabled = item.chooseed
        item.title = item.name
        item.id = item.id + ''
        item.value = item.id
        item.key = (item.pId || 0) + '-' + item.id

        if (item.children || item.child) {
          item.children = item.children || item.child || []

          for (let child of item.children) {
            child.pId = (item.pId || 0) + '-' + item.id
            child.pName = item.pName + '/' + item.name
          }
          this.setTreeOptions(item.children)
        }
        return item
      })
      return arr
    },

    setLevelOptions (options) {
      const { fieldconfig = {} } = this.row.currField
      const { type } = fieldconfig
      let arr = []

      if (type === 1) {
        arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
      } else if (type === 2) {
        arr = ['一星', '二星', '三星', '四星', '五星', '六星', '七星']
      }

      options.forEach((item, i) => {
        item.name = arr[i]
      })
      return options
    },

    handleChangeSelect (value) {
      if (value === 'empty') {
        value = undefined
        // this.$set(this.data, 'chooseed', false)
        return
      }

      if (!value) {
        let { weoptionkey } = this.data
        this.row.options.forEach((option, i) => {
          if (option.id === weoptionkey) {
            option.disabled = false
            option.chooseed = false
          }
        })
        value = undefined
      }

      this.data.weoptionkey = value
      this.$emit('change', this.data.weoptionkey, this.data)
      this.$forceUpdate()
    },

    /* 下拉选项，选择过的隐藏 */
    setSelectOptionChooseed () {
      let field = this.row
      for (let len = field.options.length, i = 0; i < len; i++) {
        let item = field.options[i]
        this.$set(item, 'chooseed', false)

        if (this.allOptionSelected.length && this.allOptionSelected.includes(item.id)) {
          this.$set(item, 'chooseed', true)
        }
      }
      this.$forceUpdate()
    },

    handleChangeTree (value) {
      if (!value) {
        value = ''
      }
      this.data.weoptionkey = value || ''
      this.$emit('change', this.data.weoptionkey)

      this.isSelectTree = true

      this.setSelectTreeOptionChooseed(value)
    },

    /* 树形选择，选择过的选项置灰 */
    setSelectTreeOptionChooseed () {
      let field = this.row
      field.options = this.renderTreeSelectNodesChoose(field.options)
      this.$forceUpdate()
    },

    renderTreeSelectNodesChoose (children = []) {
      const setData = children.map(item => {
        this.$set(item, 'disabled', false)
        this.$set(item, 'chooseed', false)

        if (this.allOptionSelected.length && this.allOptionSelected.includes(item.id)) {
          this.$set(item, 'disabled', true)
          this.$set(item, 'chooseed', true)
          this.$forceUpdate()
        }

        if (item.children && item.children.length) {
          this.renderTreeSelectNodesChoose(item.children)
        }
        return item
      })
      return setData
    },

    focusSelectTree () {
      let { weoptionkey } = this.data
      this.setSelectTreeOptionChooseed(weoptionkey)
    },

    handleVisibleSelect () {
      this.filterOptions = this.newOptions.filter(item => !item.chooseed)
    }
  }
}
</script>

<style lang="scss">
.wefieldkey-child-select {
  .hide {
    display: none;
  }
  .empty {
    text-align: center;
    color: #b3b3b3;
    .iconfont {
      display: block;
      margin: 10px 0 8px;
      text-align: center;
      color: #D6D6D6;
      font-size: 24px;
    }
    &.ant-select-dropdown-menu-item,
    &.ant-select-dropdown-menu-item:hover {
      background: none;
    }
    .ant-select-selected-icon {
      display: none;
    }
  }
  .ant-select-dropdown-menu-item-disabled:hover {
    background: none;
  }
}
</style>
